import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { PipesModule } from '../../../pipes/pipes.module';
import { VotingMessageComponent } from './voting-message/voting-message';
import { VotingQuestionComponent } from './voting-question/voting-question';
import { VotingSingleQuestionComponent } from './voting-question/single-question/single-question';
import { VotingCodeComponent } from './voting-code/voting-code';
import { VotingTimerComponent } from './voting-timer/voting-timer';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    IonicModule,
    TranslateModule,
    PipesModule,
    RoundProgressModule
  ],
  exports: [
    VotingMessageComponent,
    VotingQuestionComponent,
    VotingSingleQuestionComponent,
    VotingCodeComponent,
    VotingTimerComponent
  ],
  declarations: [
    VotingMessageComponent,
    VotingQuestionComponent,
    VotingSingleQuestionComponent,
    VotingCodeComponent,
    VotingTimerComponent
  ],
  providers: [],
})
export class VotingComponentsModule { }



// WEBPACK FOOTER //
// ./src/pages/voting/components/voting-component.module.ts